<script setup lang="ts">
  import DocumentInfoAccordion from '../document-info/DocumentInfoAccordion.vue';
  import ExternalDocumentRulesSection from './ExternalDocumentRulesSection.vue';
  import ExternalDocumentExamplesSection from './ExternalDocumentExamplesSection.vue';
  import ExternalDocumentIncorrectExamplesSection from './ExternalDocumentIncorrectExamplesSection.vue';
  import { IconImage } from '@/shared/ui';
  import InfoIcon from '@/shared/assets/icons/InfoIcon.svg';
</script>

<template>
  <div
    id="document-info"
    class="text-sm divide-y flex flex-col divide-border-color"
  >
    <div class="flex gap-2 py-4">
      <IconImage
        :src="InfoIcon"
        alt="Info"
        class="text-gray-03"
      />
      <h2 class="text-gray-07 text-sm font-semibold">
        Informações importantes
      </h2>
    </div>

    <DocumentInfoAccordion title="Regras importantes">
      <ExternalDocumentRulesSection />
    </DocumentInfoAccordion>

    <DocumentInfoAccordion title="Exemplos corretos">
      <ExternalDocumentExamplesSection />
    </DocumentInfoAccordion>

    <DocumentInfoAccordion title="Exemplos incorretos">
      <ExternalDocumentIncorrectExamplesSection />
    </DocumentInfoAccordion>
  </div>
</template>
